import { useEffect } from 'react';
import { usePrevious } from './usePrevious';
/**
 *  Keeps track of what we have shown and index
 *  in order to properly dismiss the callout if the element unmounts
 */
export function useWatchElementUnmount(currentStepIndex, anchorElement, onComplete) {
    var prevIndex = usePrevious(currentStepIndex);
    var prevElement = usePrevious(anchorElement);
    useEffect(function () {
        var sameIndex = prevIndex === currentStepIndex;
        var elmentUnmounted = !!prevElement && !anchorElement;
        // If we have shown the callout and the anchor element is unmounted
        // dismiss the callout
        if (sameIndex && elmentUnmounted) {
            onComplete('unmounted');
        }
    }, [prevIndex, prevElement, currentStepIndex, onComplete, anchorElement]);
}
//# sourceMappingURL=useWatchElementUnmount.js.map